const translations = {
    customerFieldPlaceholder: 'Add Customer',
    dueDateFieldPlaceholder: 'Due Date',
    invoiceDateFieldPlaceholder: 'Invoice Date',
    termsFieldPlaceholder: 'Terms'
};

export default translations;
